import React, { Component } from 'react';

export default class GoalsCardItem extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }

        //methods
        this.selectGoal = this.selectGoal.bind(this);
        this.deleteGoal = this.deleteGoal.bind(this);
        this.handleArchive = this.handleArchive.bind(this);
        this.goInfo = this.goInfo.bind(this);
        this.goEdit = this.goEdit.bind(this);
        this.goResults = this.goResults.bind(this);

    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    selectGoal() {
        this.props.handleSelectGoal(this.props.identity);
    }

    deleteGoal() {
        this.props.handleDelete(this.props.identity);
    }

    handleArchive() {
        if (this.props.category != "active") {
            this.props.handleArchive(this.props.identity, this.props.category === "complete");
        }
    }

    goInfo() {
        this.props.handleModeChange("info");
    }

    goEdit() {
        this.props.startEditGoal();
    }

    goResults() {
        // this.props.handleModeChange("results");
        this.props.startResultsGoal();
    }

    render() {

        let identity = this.props.identity;

        let outerClass = 'settings-card-item-outer';
        if (this.props.isActive) {
            outerClass += ' settings-card-item-outer--active';
        }

        return (
            <div className={outerClass}>
                <div className="settings-card-item-icon-container" onClick={this.selectGoal}>
                    <div className="settings-card-item-icon">
                        <svg className="settings-card-item-svg" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.896 28.896">
                            <polygon points="17.698,0 14.448,4.334 11.198,0 4.948,0 14.448,12.667 23.948,0 		" />
                            <polygon points="17.085,18.009 14.448,12.667 11.811,18.009 5.915,18.865 10.182,23.025 9.175,28.896 14.448,26.125 19.722,28.896 18.714,23.025 22.98,18.865 		" />
                        </svg>
                    </div>
                </div>
                <div className="settings-card-name-container" onClick={this.selectGoal}>
                    <div className="settings-card-name">{identity.name}</div>
                    <div className="settings-card-secondary">{identity.description}</div>
                </div>
                <div className="settings-card-bottom-container">
                    <div className="material-icons settings-card-bottom-item" onClick={this.goInfo}>info_outline</div>
                    {
                        identity.isArchived ? null  :
                            <div className="material-icons settings-card-bottom-item" onClick={this.goResults}>star_border</div>
                    }
                    {
                        this.props.category === "active" ? (<div className="material-icons settings-card-bottom-item" onClick={this.goEdit}>edit</div>) : null
                    }
                    {
                        this.props.category === "active" ? null : (identity.isArchived ? (<div className="material-icons settings-card-bottom-item" onClick={this.handleArchive}>unarchive</div>) :
                        (<div className="material-icons settings-card-bottom-item" onClick={this.handleArchive}>archive</div>))
                    }
                    <div className="material-icons settings-card-bottom-item" onClick={this.deleteGoal}>delete</div>
                </div>
            </div>
        );
    }
}